<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline"
              @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['ipsys.eventName']">
              <a-select v-model='queryParam.appId' :placeholder="language['column.pleaseChoose'] + language['ipsys.eventName']"  :disabled='appLimit.flag'  >
                <a-select-option v-for='(v,k) in appDataMap' :key='k' :value='k' :label='v'>
                  {{ v }}
                </a-select-option>
              </a-select>
            </a-form-item>

          </a-col>
          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <a-form-item :label="language['gift_vendor_code']">
              <a-input :placeholder="language['common.pleaseInput'] + language['gift_vendor_code']"
                       v-model="queryParam.bcode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <a-form-item :label="language['gift_vendor_name']">
              <a-input :placeholder="language['common.pleaseInput'] + language['gift_vendor_name']"
                       v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <a-form-item :label="language['gift_merchant_name']">
              <a-input :placeholder="language['common.pleaseInput'] + language['gift_merchant_name']"
                       v-model="queryParam.businessName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <a-form-item :label="language['platform.roleUser.columns2.status']">
              <j-dict-select-tag v-model="queryParam.approveStatus"
                                 :type="'list'"
                                 dictCode="gift_approveStatus"
                                 :disabled="formDisabled" />
            </a-form-item>
          </a-col>
          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <span style="float: left;overflow: hidden;"
                  class="table-page-search-submitButtons">
              <a-button type="primary"
                        @click="searchQuery"
                        icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary"
                        @click="searchReset"
                        icon="reload"
                        style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd"
                type="primary"
                icon="plus"
                v-has="'supplier:add'">{{language['common.insertButton']}}</a-button>
      <a-button type="primary"
                icon="download"
                @click="handleExportXls('商戶列表')"
                v-has="'supplier:export'">{{language['common.exportButton']}}</a-button>

      <a-button type="primary" icon="download" v-has="'supplier:import'" @click="downloadTemplate()">{{language['common.import.template.download']}}</a-button>

      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import" v-has="'supplier:import'" >{{language['common.importButton']}}</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1"
                       @click="batchDel">
            <a-icon type="delete" />{{language['common.delete']}}
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"
                  v-has="'supplier:delete'">{{language['common.batchAction']}}
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info"
           style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}}  <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px"
           @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table ref="table"
               size="middle"
               :scroll="{x:true}"
               bordered
               rowKey="id"
               :columns="columns"
               :dataSource="dataSource"
               :pagination="ipagination"
               :loading="false"
               :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
               class="j-table-force-nowrap"
               @change="handleTableChange">

        <span slot="action"
              slot-scope="text, record">
          <div v-if="record.approveStatus === 0">
            <a @click="handlePassAndRefuse(record,1)"
               v-has="'supplier:pass'">{{language['gift_vendor_pass']}}</a>
            <a-divider type="vertical" />
            <a @click="handlePassAndRefuse(record,2)"
               v-has="'supplier:refuse'">{{language['common.reject']}}</a>
          </div>
          <div v-else>
            <a @click="handleEdit(record)"
               v-has="'supplier:edit'">{{language['common.edit']}}</a>

            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">{{language['common.more']}}
                <a-icon type="down" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
                </a-menu-item>
                <a-menu-item v-has="'supplier:delete'">
                  <a-popconfirm :title="language['common.deleteConfirmInfo']"
                                @confirm="() => handleDelete(record)">
                    <a>{{language['common.delete']}}</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </span>

        <span slot='appName' slot-scope='appId,record,index'>
          {{ appDataMap[appId] }}
        </span>

        <span slot="customStatus"
              slot-scope="status, record, idx">
          <a-switch :checked='status'
                    @change="onSwitchChange(status,record, idx)"
                    :disabled=' record.approveStatus === 0 || record.approveStatus === 2'></a-switch>
        </span>

      </a-table>
    </div>

    <gift-vendor-modal ref="modalForm"
                       @ok="modalFormOk" :app-data-map='appDataMap' ></gift-vendor-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import GiftVendorModal from './modules/GiftVendorModal'
import { httpAction, getAction, postAction, deleteAction,downFile } from '@/api/manage'

export default {
  name: 'GiftVendorList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    GiftVendorModal,
  },
  data() {
    const language = this.$store.getters.language
    return {
      disableMixinCreated: true,
      description: 'gift_vendor管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: language['ipsys.eventName'],
          align: 'center',
          dataIndex: 'appId',
          scopedSlots: { customRender: 'appName' },
        },
        {
          title: language['gift_vendor_code'],
          align: 'center',
          dataIndex: 'bcode',
        },
        {
          title: language['gift_vendor_name'],
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: language['gift_merchant_code'],
          align: 'center',
          dataIndex: 'code',
        },
        {
          title: language['gift_merchant_name'],
          align: 'center',
          dataIndex: 'businessName',
        },
        {
          title: language['platform.roleUser.columns2.status'],
          align: 'center',
          dataIndex: 'approveStatus_dictText',
        },
        {
          title: language['construct.contactPerson'],
          align: 'center',
          dataIndex: 'contact',
        },
        {
          title: language['ipsys.contact_no'],
          align: 'center',
          dataIndex: 'phone',
        },
        // {
        //   title: '抽佣比例(%)',
        //   align: 'center',
        //   dataIndex: 'commission',
        // },
        {
          title: language['gift_vendor_address'],
          align: 'center',
          dataIndex: 'address',
        },
        // {
        //   title: '账期',
        //   align: 'center',
        //   dataIndex: 'paymentDays_dictText',
        // },
        {
          title: language['gift_up_down'],
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'customStatus' },
        },
        // {
        //   title: '审核人',
        //   align: 'center',
        //   dataIndex: 'apprvoeName',
        // },
        // {
        //   title: '审核时间',
        //   align: 'center',
        //   dataIndex: 'apprvoeTime',
        // },
        {
          title: language['common.action'],
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/gift/vendor/list',
        delete: '/gift/vendor/delete',
        deleteBatch: '/gift/vendor/deleteBatch',
        exportXlsUrl: '/gift/vendor/export',
        importExcelUrl: 'gift/vendor/import',
        passAndRefuseUrl: '/gift/vendor/passAndRefuse',
        turnStatus: '/gift/vendor/turnStatus',
        getAppDataMap: '/gift/app/queryAllMap',
        importTemplate: '/gift/vendor/exportTemplate',
        checkAppLimit: '/gift/app/checkAppLimit/id',
      },
      appDataMap:[],
      appLimit:{
        flag: false,
        value: undefined
      }
    }
  },
  created() {
    this.checkAppLimit();
    this.getAppDataMap();
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
    language() {
      return this.$store.getters.language
    },
  },
  methods: {
    searchReset(){
      this.queryParam = {};
      if (this.appLimit.flag){
        this.queryParam.appId = this.appLimit.value;
      }
      this.supplierCode = undefined;
      this.loadData(1);
    },
    async checkAppLimit(){
      await getAction(this.url.checkAppLimit).then(res=>{
        if (res.success){
          this.appLimit.flag = true;
          this.appLimit.value = res.result;
          this.queryParam.appId = res.result;
        }
      })
      this.loadData(1);
    },
    downloadTemplate(){
      let fileName = "商戶導入模板"
      downFile(this.url.importTemplate).then((data)=>{
        if (!data) {
          this.$message.warning(this.language['common.fileDowloadError'])
          return
        }
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
          window.navigator.msSaveBlob(new Blob([data],{type: 'application/vnd.ms-excel'}), fileName+'.xls')
        }else{
          let url = window.URL.createObjectURL(new Blob([data],{type: 'application/vnd.ms-excel'}))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', fileName+'.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      })
    },
    getAppDataMap(){
      getAction(this.url.getAppDataMap).then(res=>{        
        this.appDataMap = res.result;
      })
    },
    handleDelete: function (record) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!')
        return
      }
      var that = this
      deleteAction(that.url.delete, { code: record.code }).then((res) => {
        if (res.success) {
          //重新计算分页问题
          that.reCalculatePage(1)
          that.$message.success(res.message)
          that.loadData()
          this.onClearSelected()
        } else {
          that.$message.warning(res.message)
        }
      })
    },

    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!')
        return
      }

      console.log('this.selectionRows : ', this.selectionRows)
      if (this.selectionRows.length <= 0) {
        this.$message.warning('請選擇一條記錄！')
        return
      } else {
        let codeList = this.selectionRows.map((item, index, arr) => {
          let c = { code: item.code }
          return c
        })
        let ids = codeList.map((item) => item.code).join(',')

        var that = this
        this.$confirm({
          title: '確認刪除',
          content: '是否刪除選中數據?',
          onOk: function () {
            that.loading = true
            deleteAction(that.url.deleteBatch, { codes: ids })
              .then((res) => {
                if (res.success) {
                  //重新计算分页问题
                  that.reCalculatePage(that.selectedRowKeys.length)
                  that.$message.success(res.message)
                  that.loadData()
                  that.onClearSelected()
                } else {
                  that.$message.warning(res.message)
                }
              })
              .finally(() => {
                that.loading = false
              })
          },
        })
      }
    },

    handlePassAndRefuse(record, approveStatus) {
      record.approveStatus = approveStatus
      httpAction(this.url.passAndRefuseUrl, record, 'put').then((res) => {
        if (res.success) {
          this.searchQuery()
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    onSwitchChange(checked, record, idx) {
      console.log('data', this.dataSource)
      console.log('checked', checked)
      console.log('record', record)
      postAction(this.url.turnStatus, record).then((res) => {
        if (res.success) {
          // this.loadData();
          if (this.dataSource[idx]) this.dataSource[idx].status = checked === 0 ? 1 : 0
          return true
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },


  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
